(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ch-subscriber-discount"] && !Shopify.designMode) return;
  try {
    (() => {
    function prepareSubscriberOffer() {
      const notice = document.querySelector('[data-ch-subscriber-offer]');
      if (!notice || window.Shopify?.designMode) return;
      const url = new URL(window.location.href);
      if (url.searchParams.get('ch_subscriber_offer') === 'ready') {
        try { sessionStorage.removeItem('ch-newsletter-scroll'); } catch (_) { /* Optional cleanup for V2. */ }
        notice.hidden = false;
        notice.querySelector('button').addEventListener('click', () => { notice.hidden = true; });
        url.searchParams.delete('ch_subscriber_offer');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        return;
      }
      const success = document.querySelector(
        '.ch-footer__note--success, [data-ch-promo-popup-result="success"], .ch-newsletter .newsletter__form-message'
      );
      if (!success || !success.closest('form')?.querySelector('input[name="form_type"][value="customer"]')) return;
      const drop = new URL(notice.dataset.dropUrl, window.location.origin);
      drop.searchParams.set('ch_subscriber_offer', 'ready');
      const destination = drop.pathname + drop.search;
      const root = window.Shopify?.routes?.root || '/';
      window.location.replace(root + 'discount/NEWSLETTER15?redirect=' + encodeURIComponent(destination));
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prepareSubscriberOffer, { once: true });
    } else {
      prepareSubscriberOffer();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
